import { reduxForm } from 'redux-form';

import AddMembershipsForm from './AddMembershipsForm';

export default reduxForm({ form: 'addMembershipsForm' })(AddMembershipsForm);
